{
	"title": "Sie müssen sich anmelden",
	"description": "Um diese Seite anzuzeigen, müssen Sie angemeldet sein. Bitte melden Sie sich an. Danach werden Sie zur gewünschten Seite weitergeleitet.",
	"primaryButtonTitle": "Login öffnen"
}
